// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message_c38f3cee {
  display: flex;
  align-items: center;
  background: transparent;
  border: 0.084rem solid transparent;
  font-weight: 600;
  padding: 0 2rem;
}
.message_without-first-icon_c38f3cee {
  padding-left: 1.334rem;
}
.message_error_c38f3cee {
  background-color: #fee0d0;
  color: #b32700;
  --close-icon-color: #b32700;
}
.message_success_c38f3cee {
  background-color: #e3f4f4;
}
.message_info_c38f3cee {
  background-color: #dceffa;
  --close-icon-color: #11304d;
}
.message_warning_c38f3cee {
  background-color: #fef3db;
  --close-icon-color: #11304d;
}
.message__icon_c38f3cee {
  display: flex;
  font-weight: 400;
}
.message__icon_close_c38f3cee {
  margin: 0;
  cursor: pointer;
  font-size: 1.334rem;
  color: var(--close-icon-color, #26649e);
}
.message__body_c38f3cee {
  font-family: PitchBookFont, 'Helvetica', 'Arial', sans-serif;
  line-height: 1.715;
  letter-spacing: normal;
  font-stretch: normal;
  font-weight: inherit;
  flex-grow: 1;
  padding: 1rem 2rem 1rem 0.667rem;
  word-wrap: break-word;
  width: calc(100% - 2rem);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"message": `message_c38f3cee`,
	"message_without-first-icon": `message_without-first-icon_c38f3cee`,
	"message_error": `message_error_c38f3cee`,
	"message_success": `message_success_c38f3cee`,
	"message_info": `message_info_c38f3cee`,
	"message_warning": `message_warning_c38f3cee`,
	"message__icon": `message__icon_c38f3cee`,
	"message__icon_close": `message__icon_close_c38f3cee`,
	"message__body": `message__body_c38f3cee`
};
export default ___CSS_LOADER_EXPORT___;
